export const CREATE_A_LINK = 'create_a_link';
export const ALLOW_COMMENTS = 'allow_comments';
export const ADD_DEADLINE = 'add_deadline';
export const SEND_LINK_VIA_EMAIL = 'send_link_via_email';
export const COPY_LINK = 'copy_link';
export const START_COMMENTING = 'start_commenting';
export const VIEW_PARTICIPANTS = 'view_participants';
export const INVITE_PEOPLE = 'invite_people';
export const ADD_MORE_PEOPLE = 'add_more_people';
export const SAVE_TO_LOCAL = 'save-to-local';
export const PRINT = 'print';
export const VIEW_ACTIVITY = 'view_activity';
export const COPY_SHARED_LINK = 'copy_shared_link';
export const DELETE_SHARED_FILE = 'delete_shared_file';
export const SUBSCRIBE = 'subscribe';
export const NOTIFICATION_BELL = 'notification_bell';
export const MAKE_ALL_AS_READ = 'make_all_as_read';
export const MY_ACCOUNT = 'my_account';
export const EXIT = 'exit';
export const PRIVACY_POLICY = 'privacy_policy';
export const TERM_OF_SERVICE = 'term_of_service';
export const SHARED_BY_YOU_TAB = 'shared_by_you_tab';
export const SHARED_BY_OTHERS_TAB = 'shared_by_others_tab';
export const SWITCH_TO_LIST_VIEW = 'switch_to_list_view';
export const SWITCH_TO_THUMBNAIL_VIEW = 'switch_to_thumbnail_view';
export const UNSHARE_FILES = 'unshare_files';
export const DELETE_SHARED_FILES = 'delete_shared_files';
export const ADD_DEADLINE_BY_YOU = 'add_deadline_by_you';
export const VIEW_ACTIVITY_BY_YOU = 'view_activity_by_you';
export const COPY_SHARED_LINK_BY_YOU = 'copy_shared_link_by_you';
export const UNSHARE_FILE = 'unshare_file';
export const VIEW_PARTICIPANTS_BY_YOU = 'view_participants_by_you';
export const DOWNLOAD_FILE = 'download_file';
export const VIEW_ACTIVITY_BY_OTHERS = 'view_activity_by_others';
export const COPY_SHARED_LINK_BY_OTHERS = 'copy_shared_link_by_others';
export const REMOVE_ME = 'remove_me';
export const REMOVE_MES = 'remove_mes';
export const VIEW_PARTICIPANTS_BY_OTHERS = 'view_participants_by_others';
export const ShareReview = {
  [CREATE_A_LINK]: { category: 'ShareReview', action: CREATE_A_LINK },
  [ALLOW_COMMENTS]: { category: 'ShareReview', action: ALLOW_COMMENTS },
  [ADD_DEADLINE]: { category: 'ShareReview', action: ADD_DEADLINE },
  [SEND_LINK_VIA_EMAIL]: {
    category: 'ShareReview',
    action: SEND_LINK_VIA_EMAIL,
  },
  [COPY_LINK]: { category: 'ShareReview', action: COPY_LINK },
  [START_COMMENTING]: { category: 'ShareReview', action: START_COMMENTING },
  [VIEW_PARTICIPANTS]: { category: 'ShareReview', action: VIEW_PARTICIPANTS },
  [INVITE_PEOPLE]: { category: 'ShareReview', action: INVITE_PEOPLE },
  [ADD_MORE_PEOPLE]: { category: 'ShareReview', action: ADD_MORE_PEOPLE },
};

export const RIGHT_TOP_FREE = 'RIGHT_TOP_FREE';
export const RIGHT_TOP_UPGRADE = 'RIGHT_TOP_UPGRADE';
export const LEFT_BOTTOM_FREE = 'LEFT_BOTTOM_FREE';
export const LEFT_BOTTOM_UPGRADE = 'LEFT_BOTTOM_UPGRADE';

export const YEAR_FREE_SUBMIT = 'YEAR_FREE_SUBMIT';
export const MONTH_FREE_SUBMIT = 'MONTH_FREE_SUBMIT';
export const YEAR_MONTH_FREE_SUBMIT = 'YEAR_MONTH_FREE_SUBMIT';
export const YEAR_UPGRADE_SUBMIT = 'YEAR_UPGRADE_SUBMIT';
export const MONTH_UPGRADE_SUBMIT = 'MONTH_UPGRADE_SUBMIT';
export const YEAR_MONTH_UPGRADE_SUBMIT = 'YEAR_MONTH_UPGRADE_SUBMIT';
export const YEAR_FREE_SUCCESS = 'YEAR_FREE_SUCCESS';
export const YEAR_FREE_FAIL = 'YEAR_FREE_FAIL';
export const MONTH_FREE_SUCCESS = 'MONTH_FREE_SUCCESS';
export const MONTH_FREE_FAIL = 'MONTH_FREE_FAIL';
export const YEAR_MONTH_FREE_SUCCESS = 'YEAR_MONTH_FREE_SUCCESS';
export const YEAR_MONTH_FREE_FAIL = 'YEAR_MONTH_FREE_FAIL';
export const YEAR_UPGRADE_SUCCESS = 'YEAR_UPGRADE_SUCCESS';
export const YEAR_UPGRADE_FAIL = 'YEAR_UPGRADE_FAIL';
export const MONTH_UPGRADE_SUCCESS = 'MONTH_UPGRADE_SUCCESS';
export const MONTH_UPGRADE_FAIL = 'MONTH_UPGRADE_FAIL';
export const YEAR_MONTH_UPGRADE_SUCCESS = 'YEAR_MONTH_UPGRADE_SUCCESS';
export const YEAR_MONTH_UPGRADE_FAIL = 'YEAR_MONTH_UPGRADE_FAIL';
export const SUBSCRIBE_FUNCTION_CLICK = 'SUBSCRIBE_FUNCTION_CLICK';
export const YEAR_FREE = 'YEAR_FREE';
export const MONTH_FREE = 'MONTH_FREE';
export const YEAR_MONTH_FREE = 'YEAR_MONTH_FREE';
export const YEAR_UPGRADE = 'YEAR_UPGRADE';
export const MONTH_UPGRADE = 'MONTH_UPGRADE';
export const YEAR_MONTH_UPGRADE = 'YEAR_MONTH_UPGRADE';
export const NEED_NAV_AFTER_PAY = 'MAY_NEED_NAV_AFTER_PAY_DLG';
export const USER_FROM_WEBSITE_LINK = 'USER_FROM_WEBSITE_LINK';
export const USER_FROM_DIRECT_LINK = 'USER_FROM_DIRECT_LINK';
export const BUNDLE_SUITE_PRO_FOR_TEAMS = 'BUNDLE_SUITE_PRO_FOR_TEAMS';
export const BUNDLE_SUITE_PRO_FOR_INDIVIDUAL = 'BUNDLE_SUITE_PRO_FOR_INDIVIDUAL';
export const BUNDLE_SUITE_FOR_TEAMS = 'BUNDLE_SUITE_FOR_TEAMS';
export const BUNDLE_SUITE_FOR_INDIVIDUAL = 'BUNDLE_SUITE_FOR_INDIVIDUAL';

export const SUBSCRIBE_ACTION_MAP = {
  [RIGHT_TOP_FREE]: {
    eventKey: 'RIGHT_TOP_FREE',
    label: 'user_subscribe',
  },
  [RIGHT_TOP_UPGRADE]: {
    eventKey: 'RIGHT_TOP_UPGRADE',
    label: 'user_subscribe',
  },
  [LEFT_BOTTOM_FREE]: {
    eventKey: 'LEFT_BOTTOM_FREE',
    label: 'user_subscribe',
  },
  [LEFT_BOTTOM_UPGRADE]: {
    eventKey: 'LEFT_BOTTOM_UPGRADE',
    label: 'user_subscribe',
  },
  [YEAR_FREE_SUBMIT]: {
    eventKey: 'YEAR_FREE_SUBMIT',
    label: 'user_subscribe',
  },
  [MONTH_FREE_SUBMIT]: {
    eventKey: 'MONTH_FREE_SUBMIT',
    label: 'user_subscribe',
  },
  [YEAR_MONTH_FREE_SUBMIT]: {
    eventKey: 'YEAR_MONTH_FREE_SUBMIT',
    label: 'user_subscribe',
  },
  [YEAR_UPGRADE_SUBMIT]: {
    eventKey: 'YEAR_UPGRADE_SUBMIT',
    label: 'user_subscribe',
  },
  [MONTH_UPGRADE_SUBMIT]: {
    eventKey: 'MONTH_UPGRADE_SUBMIT',
    label: 'user_subscribe',
  },
  [YEAR_MONTH_UPGRADE_SUBMIT]: {
    eventKey: 'YEAR_MONTH_UPGRADE_SUBMIT',
    label: 'user_subscribe',
  },
  [YEAR_FREE_SUCCESS]: {
    eventKey: 'YEAR_FREE_SUCCESS',
    label: 'user_subscribe',
  },
  [YEAR_FREE_FAIL]: {
    eventKey: 'YEAR_FREE_FAIL',
    label: 'user_subscribe',
  },
  [MONTH_FREE_SUCCESS]: {
    eventKey: 'MONTH_FREE_SUCCESS',
    label: 'user_subscribe',
  },
  [MONTH_FREE_FAIL]: {
    eventKey: 'MONTH_FREE_FAIL',
    label: 'user_subscribe',
  },
  [YEAR_MONTH_FREE_SUCCESS]: {
    eventKey: 'YEAR_MONTH_FREE_SUCCESS',
    label: 'user_subscribe',
  },
  [YEAR_MONTH_FREE_FAIL]: {
    eventKey: 'YEAR_MONTH_FREE_FAIL',
    label: 'user_subscribe',
  },
  [YEAR_UPGRADE_SUCCESS]: {
    eventKey: 'YEAR_UPGRADE_SUCCESS',
    label: 'user_subscribe',
  },
  [YEAR_UPGRADE_FAIL]: {
    eventKey: 'YEAR_UPGRADE_FAIL',
    label: 'user_subscribe',
  },
  [MONTH_UPGRADE_SUCCESS]: {
    eventKey: 'MONTH_UPGRADE_SUCCESS',
    label: 'user_subscribe',
  },
  [MONTH_UPGRADE_FAIL]: {
    eventKey: 'MONTH_UPGRADE_FAIL',
    label: 'user_subscribe',
  },
  [YEAR_MONTH_UPGRADE_SUCCESS]: {
    eventKey: 'YEAR_MONTH_UPGRADE_SUCCESS',
    label: 'user_subscribe',
  },
  [YEAR_MONTH_UPGRADE_FAIL]: {
    eventKey: 'YEAR_MONTH_UPGRADE_FAIL',
    label: 'user_subscribe',
  },
  [SUBSCRIBE_FUNCTION_CLICK]: {
    eventKey: 'SUBSCRIBE_FUNCTION_CLICK',
    label: 'user_subscribe',
  },
  [BUNDLE_SUITE_PRO_FOR_TEAMS]: {
    eventKey: 'BUNDLE_SUITE_PRO_FOR_TEAMS',
    label: 'user_subscribe',
  },
  [BUNDLE_SUITE_PRO_FOR_INDIVIDUAL]: {
    eventKey: 'BUNDLE_SUITE_PRO_FOR_INDIVIDUAL',
    label: 'user_subscribe',
  },
  [BUNDLE_SUITE_FOR_TEAMS]: {
    eventKey: 'BUNDLE_SUITE_FOR_TEAMS',
    label: 'user_subscribe',
  },
  [BUNDLE_SUITE_FOR_INDIVIDUAL]: {
    eventKey: 'BUNDLE_SUITE_FOR_INDIVIDUAL',
    label: 'user_subscribe',
  },
};

export const EVENT_SHARE = {
  CREATE_A_LINK,
  ALLOW_COMMENTS,
  SEND_LINK_VIA_EMAIL,
  COPY_LINK,
  START_COMMENTING,
  VIEW_PARTICIPANTS,
  INVITE_PEOPLE,
  SAVE_TO_LOCAL,
  PRINT,
  ADD_DEADLINE,
  VIEW_ACTIVITY,
  COPY_SHARED_LINK,
  UNSHARE_FILE,
  DELETE_SHARED_FILE,
  SUBSCRIBE,
  NOTIFICATION_BELL,
  MAKE_ALL_AS_READ,
  MY_ACCOUNT,
  EXIT,
  PRIVACY_POLICY,
  TERM_OF_SERVICE,
  SHARED_BY_YOU_TAB,
  SHARED_BY_OTHERS_TAB,
  SWITCH_TO_LIST_VIEW,
  SWITCH_TO_THUMBNAIL_VIEW,
  UNSHARE_FILES,
  DELETE_SHARED_FILES,
  ADD_DEADLINE_BY_YOU,
  VIEW_ACTIVITY_BY_YOU,
  COPY_SHARED_LINK_BY_YOU,
  VIEW_PARTICIPANTS_BY_YOU,
  ADD_MORE_PEOPLE,
  DOWNLOAD_FILE,
  VIEW_ACTIVITY_BY_OTHERS,
  COPY_SHARED_LINK_BY_OTHERS,
  REMOVE_ME,
  REMOVE_MES,
  VIEW_PARTICIPANTS_BY_OTHERS,
};